import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { useState } from "react";
import InputSelectForSigorta from "../shared/input/new/InputSelectForSigorta";
import { useEffect } from "react";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme, sendStatus }) => sendStatus ? "#39fc0351" : theme.secondaryBgColor };

  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      background-color: ${({ theme, sendStatus }) => sendStatus ? "#f5faf451" : "var(--color-light)" };
      .row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          width: 150px;
          margin-right: 10px;
        }
      }
    }
  }
`;

const options = [
  {
    id:1,
    text: "Aranmadı.",
  },
  {
    id:2,
    text: "Arandı.",
  }
]
const SigortaListesiContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  const [sendStatus, setSendStatus] = useState(data.durum)

  useEffect(()=> {
    setSendStatus(options.find(item => item.text === data.durum))
  },[])

  return (
    <Container theme={theme} sendStatus={data.durum === "Arandı."}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{data.adSoyad}</div>
            <div className="col">{data.phoneNumber}</div>
            <div className="col">{data.phoneNumber}</div>
            <div className="col">{data.sigortaTuru ? data.sigortaTuru : "-"}</div>
            <div className="col">{data.plaka ? data.plaka : "-"}</div>
            <div className="col">{data.aracTuru ? data.aracTuru : "-"}</div>
            <div className="col">{data.carYear ? data.carYear : "-"}</div>
            <div className="col">{data.aracSahibiTcNo ? data.aracSahibiTcNo : "-"}</div>
            <div className="col">{data.ruhsatSeriNo || "-"}</div>
            <div className="col">{data.aracınKaskoDegeri > 0 ? data.aracınKaskoDegeri : "-"}</div>
            <div className="col">{data.immDegeri ? data.immDegeri : "-"}</div>
            <div className="col">{moment(data.createOn).format("DD.MM.yyyy")}</div>
            <div className="col">
              <InputSelectForSigorta data={sendStatus?.text || data.durum} setData={setSendStatus} labelText={"Durum"} name={data.id +"sigortaDurum"} initialOptions={options} allData={data}/> 
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SigortaListesiContainer;
